// Document Markdown must never enable raw HTML, including when an error or
// document title is derived from a public URL. markdown-it also validates URLs.
export function configureDocsMarkdown(md) {
  md.set({ html: false })
  // md-editor-v3 interpolates fence info into its highlight HTML. Normalize
  // tokens before any preview plugin renders them (html:false alone is not enough).
  md.core.ruler.push('safe-document-fence-info', (state) => {
    const visit = (tokens) => tokens.forEach((token) => {
      if (token.type === 'fence' || token.type === 'code_block') {
        const info = (token.info || '').trim()
        token.info = /^[A-Za-z0-9_+-]{1,32}$/.test(info) ? info : ''
      }
      if (token.children) visit(token.children)
    })
    visit(state.tokens)
  })
}

export function highlightDocumentTitle(value, query) {
  const escape = (text) => text.replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]))
  const text = String(value || '')
  const terms = String(query || '').trim().split(/\s+/).filter(Boolean)
  if (!terms.length) return escape(text)
  const pattern = terms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
  const regex = new RegExp(pattern, 'gi')
  let result = ''
  let offset = 0
  for (const match of text.matchAll(regex)) {
    result += escape(text.slice(offset, match.index)) + '<mark>' + escape(match[0]) + '</mark>'
    offset = match.index + match[0].length
  }
  return result + escape(text.slice(offset))
}
